// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1Du_j","footer":"ModalError_footer__25dBU"};